<div class="display-cultural-index-organisation-orbit">
    <div class="header">
        @if (canSeeData) {
            <div>
                <!-- TODO: Date change event -->
                <dx-date-box (valueChange)="onDateChanged($any($event))"
                             [max]="today"
                             [showClearButton]="true"
                             placeholder="Today"
                             data-test="cultural-index-date"></dx-date-box>
            </div>
        }

        <div class="ms-auto btn-group">
            <button [adaptButtonToggle]="viewType === CulturalIndexViewType.Statistics"
                    adaptButtonIcon="fal fa-fw fa-chart-bar"
                    (click)="setViewType(CulturalIndexViewType.Statistics)"
                    class="btn btn-blank btn-force-text"
                    title="Statistics"></button>
            <button [adaptButtonToggle]="viewType === CulturalIndexViewType.OrbitChart"
                    adaptButtonIcon="fal fa-fw fa-chart-pie"
                    (click)="setViewType(CulturalIndexViewType.OrbitChart)"
                    class="btn btn-blank btn-force-text"
                    title="Orbit chart"></button>
            <button [adaptButtonToggle]="viewType === CulturalIndexViewType.LatestChart"
                    adaptButtonIcon="fal fa-fw fa-chart-line"
                    (click)="setViewType(CulturalIndexViewType.LatestChart)"
                    class="btn btn-blank btn-force-text"
                    title="Time chart"></button>
            @if (canSeeData) {
                <button [adaptButtonToggle]="viewType === CulturalIndexViewType.Grid"
                        adaptButtonIcon="fal fa-fw fa-table"
                        (click)="setViewType(CulturalIndexViewType.Grid)"
                        class="btn btn-blank btn-force-text"
                        title="Grid"></button>
            }
        </div>
    </div>
    <div class="body">
        <div>
            @switch (viewType) {
                @case (0) {
                    <adapt-ci-orbit-chart [date]="date"> </adapt-ci-orbit-chart>
                }
                @case (1) {
                    <adapt-ci-latest-chart [date]="date"> </adapt-ci-latest-chart>
                }
                @case (2) {
                    <adapt-ci-orbit-grid [date]="date"> </adapt-ci-orbit-grid>
                }
                @case (3) {
                    <adapt-ci-orbit-statistics [date]="date"> </adapt-ci-orbit-statistics>
                }
            }
        </div>
    </div>
</div>
